import { useApiQuery } from 'mf_core/query';

export function useGetNotificationUnreadCount() {
  return useApiQuery<any>(
    `/account-management/v1/notifications/unread-count?NotificationType=inapp&ReadStatus=unread`
  );
}
